export default "__VITE_ASSET__Th_11yII__"